import { Component, OnInit } from '@angular/core';
import { ResponseStructure } from '@iq-central-front-end/share';
import Swal from 'sweetalert2';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';
import { QuizQuestions } from '../../../_models/course';
import { PaginationInfo } from '../../../_models/pagination-info';
import { Location } from '@angular/common';

@Component({
  selector: 'iq-central-front-end-serve-quiz',
  templateUrl: './serve-quiz.component.html',
  styleUrls: ['./serve-quiz.component.scss'],
})
export class ServeQuizComponent implements OnInit {
  lessonId: any;
  quiz: any;
  quizId: any;
  result: any;
  scores: any[] = [];
  allScores: any[] = [];
  paginationResultInfo: PaginationInfo;
  quizQuestions: QuizQuestions;
  sub: Subscription = new Subscription();
  courseCode: any;
  questionIndex = 0;
  totalQuestions: any;
  answr = 0;
  rightAnswerPercent = 0;
  allAnswered: any[] = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private course: CourseService,
    private _global: GlobalService,
    private readonly location: Location
  ) {}

  ngOnInit() {
    this.getQuiz();
    this.getHistory();
  }

  getHistory() {
    this._global.showSpinner();
    this.sub.add(
      this.course.getAssessmentResultHistory(this.quiz.id, 1, 9).subscribe({
        next: (res) => {
          this._global.hideSpinner();
          this.scores = res['responseResult'];
          // console.log(this.scores);
          this.allScores = res['responseResult'].assessmentResults;

          this.paginationResultInfo = res['responseResult'].paginationInfo;
        },
      })
    );
  }

  getQuiz() {
    this.route.data.subscribe((res) => {
      this.quiz = res['resolvedData'].responseResult;
      this.quizQuestions = this.quiz['questions'];
      this.totalQuestions = this.quizQuestions['length'];
      // console.log('questions', this.quizQuestions);
    });
  }

  get newQuestion() {
    return this.fb.group({
      title: ['', Validators.required],
      answers: this.fb.array([
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
      ]),
    });
  }

  submit() {
    this._global.showSpinner();

    const payload = this.allAnswered;

    this.sub.add(
      this.course.markAssessment(this.quiz.id, payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res['responseResult']);
          this.result = res['responseResult'].grade;
          // console.log(this.result);

          const myResult = this.result;
          Swal.fire({
            title: '<i>Result</i>',
            html: Math.round(myResult) + '%',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#d33',
          });

          history.back();
        },
      })
    );
  }

  checked(questionId, answerId) {
    // console.log(this.allAnswered, questionId, answerId);

    return this.allAnswered.some(
      (answer) => answer.questionId == questionId && answer.answerId == answerId
    );
  }

  transformString(j) {
    switch (j) {
      case 0:
        return 'A';
        break;
      case 1:
        return 'B';
        break;
      case 2:
        return 'C';
        break;
      case 3:
        return 'D';
        break;
      default:
        break;
    }
  }
  
  transformNumber(i) {
    return i;
  }

  next() {
    const selectedOption = document.querySelector(
      '.radio-item input[type=radio]:checked'
    );
    const notClicked = document.querySelector('.notClicked');
    if (!selectedOption) {
      notClicked.innerHTML = 'Please select an option';
    } else {
      this.answr++;
      const answer = selectedOption['value'];
      // selectedOption['checked'] = false;
      const questionId = this.quizQuestions[this.questionIndex].id;
      const answered = {
        answerId: answer,
        questionId: questionId,
      };

      const questionExists = this.allAnswered.some(
        (answer) => answer.questionId == questionId
      );
      if (questionExists) {
        this.allAnswered = this.allAnswered.filter(
          (answer) => answer.questionId != questionId
        );
      }

      this.allAnswered.push(answered);

      // this.allAnswered.includes(this.quizQuestions[this.questionIndex].id)
      //   ? this.allAnswered.pop()
      //   : this.allAnswered.push(answered);
      this.questionIndex++;
      this.rightAnswerPercent =
        (this.answr / this.quizQuestions['length']) * 100;
      notClicked.innerHTML = '  ';
    }
  }
  back() {
    if (this.questionIndex === 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'your quiz progress will be lost',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Go back',
      }).then((result) => {
        if (result.value) {
          this.location.back();
        }
      });
    } else {
      this.questionIndex--;
      this.answr--;
      this.rightAnswerPercent =
        (this.answr / this.quizQuestions['length']) * 100;
    }
  }

  finish() {
    const answr = 0;
    const selectedOption = document.querySelector(
      '.radio-item input[type=radio]:checked'
    );
    const notClicked = document.querySelector('.notClicked');

    if (!selectedOption) {
      notClicked.innerHTML = 'Please select and option';
    } else {
      const answer = selectedOption['value'];
      selectedOption['checked'] = false;
      const answered = {
        answerId: answer,
        questionId: this.quizQuestions[this.questionIndex].id,
      };
      this.allAnswered.push(answered);

      // this.questionIndex++;
      this.rightAnswerPercent = 100;
      notClicked.innerHTML = '  ';
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'This content will be saved and you will be taken to the course overview page',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Save',
    }).then((result) => {
      if (result.value) {
        this.submit();
      }
    });
  }

  navigatePage(page) {
    this._global.showSpinner();
    this.course.getAssessmentResultHistory(this.quiz.id, page, 9).subscribe({
      next: (res) => {
        this._global.hideSpinner();
        this.scores = res['responseResult'];
        console.log(this.scores);
        this.allScores = res['responseResult'].assessmentResults;

        this.paginationResultInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  addContent(path) {}

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }
}
